"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Timestamp = void 0;
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _stylesModule = _interopRequireDefault(require("./styles.module.css"));
var _excluded = ["className", "timestamp"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
var Timestamp = exports.Timestamp = /*#__PURE__*/(0, _react.forwardRef)((_ref, ref) => {
  var className = _ref.className,
    timestamp = _ref.timestamp,
    props = _objectWithoutProperties(_ref, _excluded);
  var _useTimestamp = useTimestamp(timestamp),
    dateString = _useTimestamp.dateString;
  return /*#__PURE__*/_react.default.createElement("span", _extends({
    ref: ref,
    className: (0, _classnames.default)(className, _stylesModule.default.Timestamp)
  }, props), dateString);
});
var useTimestamp = timestamp => {
  var date = new Date(timestamp);
  var now = new Date();
  var diffInMilliseconds = now.getTime() - date.getTime();
  var diffInHours = diffInMilliseconds / (1000 * 60 * 60);
  var diffInMinutes = diffInMilliseconds / (1000 * 60);
  var diffInSeconds = diffInMilliseconds / 1000;
  var dateString;
  if (diffInHours < 24) {
    if (diffInSeconds < 10) {
      dateString = 'Just now';
    } else if (diffInMinutes < 1) {
      var seconds = Math.floor(diffInSeconds);
      dateString = "".concat(seconds, " ").concat(seconds === 1 ? 'second' : 'seconds', " ago");
    } else if (diffInHours < 1) {
      var minutes = Math.floor(diffInMinutes);
      dateString = "".concat(minutes, " ").concat(minutes === 1 ? 'minute' : 'minutes', " ago");
    } else {
      var hours = Math.floor(diffInHours);
      dateString = "".concat(hours, " ").concat(hours === 1 ? 'hour' : 'hours', " ago");
    }
  } else {
    dateString = date.toLocaleDateString('en-US', {
      month: 'short',
      day: 'numeric'
    });
  }
  return {
    dateString
  };
};
//# sourceMappingURL=Timestamp.js.map